.trigger {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-right: 12px;
  padding-left: 14px;
  border: 1px solid rgb(0 0 0 / 20%);

  &:hover {
    background-color: rgb(0 0 0 / 5%);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px white,
      0 0 0 4px rgb(0 0 0 / 50%);
  }
}

.content {
  position: relative;

  /* 企業の名前が入ったヘッダーに中身が隠れないようにするため */
  z-index: var(--z-index-mid);
  width: 192px;
  padding-block: 10px;
  background-color: var(--color-white);
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 12px;
}

.item {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  cursor: pointer;

  &[data-highlighted] {
    outline: none;
    background-color: rgb(0 0 0 / 5%);
  }
}

.itemText {
  /* icon */
  svg:first-of-type {
    width: 24px;
  }

  display: flex;
  gap: 10px;
  align-items: center;
}

.value {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.26px;
}
